var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-6 custom-page-responsiveness"},[_c('v-container',[(_vm.loading)?[_c('v-skeleton-loader',{attrs:{"type":"table-heading, divider, list-item-three-line, image, article"}})]:[_c('h1',{staticClass:"mb-7 mt-4"},[_vm._v(_vm._s(_vm.page.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.content)}})]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }